export const FETCH_AVALIABLE_LANGUAGES_REQUEST = 'i18n/FETCH_AVALIABLE_LANGUAGES_REQUEST';
export const FETCH_AVALIABLE_LANGUAGES_SUCCESS = 'i18n/FETCH_AVALIABLE_LANGUAGES_SUCCESS';
export const FETCH_AVALIABLE_LANGUAGES_FAILURE = 'i18n/FETCH_AVALIABLE_LANGUAGES_FAILURE';

export const FETCH_DEFAULT_TRANSLATIONS_REQUEST = 'i18n/FETCH_DEFAULT_TRANSLATIONS_REQUEST';
export const FETCH_DEFAULT_TRANSLATIONS_SUCCESS = 'i18n/FETCH_DEFAULT_TRANSLATIONS_SUCCESS';
export const FETCH_DEFAULT_TRANSLATIONS_FAILURE = 'i18n/FETCH_DEFAULT_TRANSLATIONS_FAILURE';

export const IS_CONTENT_EDITABLE_ENABLED = 'i18n/IS_CONTENT_EDITABLE_ENABLED';
export const UPDATE_FIELD = 'i18n/UPDATE_FIELD'

export const FETCH_TRANSLATIONS_LIST_REQUEST = 'i18n/FETCH_TRANSLATIONS_LIST_REQUEST'
export const FETCH_TRANSLATIONS_LIST_SUCCESS = 'i18n/FETCH_TRANSLATIONS_LIST_SUCCESS'
export const FETCH_TRANSLATIONS_LIST_FAILURE = 'i18n/FETCH_TRANSLATIONS_LIST_FAILURE'

export const UPDATE_TRANSLATIONS_MANUALY = 'i18n/UPDATE_TRANSLATIONS_MANUALY'
export const UPDATE_TRANSLATIONS_MANUALY_SUCCESSFULLY = 'i18n/UPDATE_TRANSLATIONS_MANUALY_SUCCESSFULLY'
export const UPDATE_TRANSLATIONS_MANUALY_FAILURE = 'i18n/UPDATE_TRANSLATIONS_MANUALY_FAILURE'